/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable @next/next/no-img-element */
import React, { useEffect, useState } from "react";
import styles from "./styles.module.scss";
import useElementOnScreen from "../../../../hooks/useElementOnScreen";
import { IMAGE_URL_v4 } from "../../../../envs/prod/constants";

const finalValueMob = [
  {
    opacity: 1,
    x: -200,
    y: 16,
  },
  {
    opacity: 1,
    x: -122,
    y: 0,
  },
  {
    opacity: 1,
    x: -50,
    y: 0,
  },
  {
    opacity: 1,
    x: 20,
    y: 0,
  },
  {
    opacity: 1,
    x: 100,
    y: 0,
  },
];
const defaultAnimationFrame = [
  {
    opacity: 0.9,
    x: -50,
    y: 100,
  },
  {
    opacity: 0.9,
    x: -50,
    y: 100,
  },
  {
    opacity: 0.9,
    x: -50,
    y: 100,
  },
  {
    opacity: 0.9,
    x: -50,
    y: 100,
  },
  {
    opacity: 0.9,
    x: -50,
    y: 100,
  },
];

export default function WatchMobile({ windowSize }) {
  const [styleZoom, setStyleZoom] = useState([
    {
      opacity: 0.9,
      x: 0,
      y: 100,
    },
    {
      opacity: 0.9,
      x: 0,
      y: 100,
    },
    {
      opacity: 0.9,
      x: 0,
      y: 100,
    },
    {
      opacity: 0.9,
      x: 0,
      y: 100,
    },
    {
      opacity: 0.9,
      x: 0,
      y: 100,
    },
  ]);
  const [containerRef, isVisible] = useElementOnScreen({
    root: null,
    rootMargin: "0px",
    thresold: 1.0,
  });
  useEffect(() => {
    if (isVisible) {
      setStyleZoom(finalValueMob);
    }
  }, [isVisible]);

  return (
    <div className={styles.watchMobile_wrapper}>
      <div className={styles.watchMobile_wrapper_heading}>
        {windowSize >= 768 ? (
          <h2 className={styles.watchMobile_heading}>
            Watch <span>new</span> videos everyday
          </h2>
        ) : (
          <h2 className={styles.watchMobile_heading}>
            Watch new series
            <br /> everyday
          </h2>
        )}
        {windowSize < 768 && (
          <img
            src="assets/landing/vector_watch.webp"
            alt="curve"
            className={styles.img_svgcurve}
          />
        )}
      </div>
      <div
        id="sentinel"
        className={styles.sentinel}
        ref={containerRef}
        style={{ height: 10, width: "100vw", background: "white" }}
      ></div>
      {styleZoom && (
        <div className={styles.watchMobile_wrapper_mob_screens}>
          <img
            alt="seekho"
            src={`${IMAGE_URL_v4}/home/mob1.webp`}
            style={{
              opacity: styleZoom[0].opacity,
              transform: `translate(${styleZoom[0].x}%, ${styleZoom[0].y}%)`,
              zIndex: 10,
            }}
            className={styles.mobile_screen}
          />
          <img
            alt="seekho"
            src={`${IMAGE_URL_v4}/home/mob2.webp`}
            style={{
              opacity: styleZoom[1].opacity,
              transform: `translate(${styleZoom[1].x}%, ${styleZoom[1].y}%)`,
              zIndex: 11,
            }}
            className={styles.mobile_screen}
          />
          <img
            alt="seekho"
            src={`${IMAGE_URL_v4}/home/mob3.webp`}
            style={{
              opacity: styleZoom[2].opacity,
              transform: `translate(${styleZoom[2].x}%, ${styleZoom[2].y}%)`,
              zIndex: 12,
            }}
            className={styles.mobile_screen}
          />
          <img
            alt="seekho"
            src={`${IMAGE_URL_v4}/home/mob4.webp`}
            style={{
              opacity: styleZoom[3].opacity,
              transform: `translate(${styleZoom[3].x}%, ${styleZoom[3].y}%)`,
              zIndex: 11,
            }}
            className={styles.mobile_screen}
          />
          <img
            alt="seekho"
            src={`${IMAGE_URL_v4}/home/mob5.webp`}
            style={{
              opacity: styleZoom[4].opacity,
              transform: `translate(${styleZoom[4].x}%, ${styleZoom[4].y}%)`,
              zIndex: 10,
            }}
            className={styles.mobile_screen}
          />
        </div>
      )}
    </div>
  );
}
